import pluralize from "pluralize";

import {Chip} from "@/components/chip/Chip.tsx";
import {Dot} from "@/components/dot/Dot.tsx";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";
import {
  ANALYZER_USAGE_CHIP_DESCRIPTIONS,
  ANALYZER_USAGE_CHIP_INDICATOR_VARIANTS,
} from "@/pages/analyzer/Analyzer.constants.ts";
import {AnalyzerUsageChipProps} from "@/pages/analyzer/Analyzer.types.ts";
import {getUsageChipState} from "@/pages/analyzer/Analyzer.utils.ts";

import styles from "./AnalyzerUsageChip.module.scss";

export const AnalyzerUsageChip = ({chip}: AnalyzerUsageChipProps) => {
  const state = getUsageChipState(chip);
  const total = chip.used + chip.selected;
  const description = ANALYZER_USAGE_CHIP_DESCRIPTIONS[chip.limitName];

  return (
    <Tooltip
      placement="top"
      tooltipContent={
        <div className={styles.tooltipBody}>
          <div className={styles.tooltipTitle}>{pluralize(chip.limitName)}</div>
          {description && <div className={styles.tooltipMuted}>{description}</div>}
          <div className={styles.tooltipMuted}>
            <span className={styles.tooltipCount}>
              {total} of {chip.limit}
            </span>{" "}
            on your plan · <span className={styles.tooltipCount}>{chip.selected}</span> from this analysis
          </div>
        </div>
      }
    >
      <Chip variant="metric" size="smallLight">
        <Dot variant={ANALYZER_USAGE_CHIP_INDICATOR_VARIANTS[state]} />
        <span className={styles.label}>{chip.tierLabel}</span>
        <span className={styles.count}>
          {total}/{chip.limit}
        </span>
      </Chip>
    </Tooltip>
  );
};
